import { NgFor } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { PQRNumeroDiasLetivosDto } from '../../dtos/pqr-numero-dias-letivos.dto';
import { Router } from '@angular/router';
import { CondicaoQualidadeStateService, EtapasDeEdicaoService } from '../../services';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import { DialogPqrPadraoNumeroDeDiasComponent } from '../../shared/dialog-pqr-padrao-numero-de-dias/dialog-pqr-padrao-numero-de-dias.component';
import { ValidadorTela } from '../../interfaces/validacao.interface';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-numero-de-dias-letivos',
  standalone: true,
  imports: [
    NgFor,
    FormsModule,
    MatIconModule,
    MatDialogModule,
    TabelaComponent,
    MatTooltipModule,
    OnlyNumbersDirective,
    MenuSuspensoComponent
  ],
  templateUrl: './numero-de-dias-letivos.component.html',
  styleUrl: './numero-de-dias-letivos.component.scss',
})
export class NumeroDeDiasLetivosComponent extends BasePqrComponent<PQRNumeroDiasLetivosDto> implements ValidadorTela {

  protected valoresPadrao: PQRNumeroDiasLetivosDto[] = [];
  protected valoresEdicao: PQRNumeroDiasLetivosDto[] = [];

  public get pqrNumeroDiasLetivosPadrao(): PQRNumeroDiasLetivosDto[] {
    return this.valoresPadrao;
  }
  public set pqrNumeroDiasLetivosPadrao(value: PQRNumeroDiasLetivosDto[]) {
    this.valoresPadrao = value;
  }

  public get pqrNumeroDiasLetivosValores(): PQRNumeroDiasLetivosDto[] {
    return this.valoresEdicao;
  }
  public set pqrNumeroDiasLetivosValores(value: PQRNumeroDiasLetivosDto[]) {
    this.valoresEdicao = value;
  }

  constructor(
    router: Router,
    toastr: ToastrService,
    dialogRestaurarValores: MatDialog,
    private dialogPqrPadraoNumeroDeDias: MatDialog,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
  ) {
    super(router, toastr, dialogRestaurarValores, dialogPqrPadraoNumeroDeDias);
  }

  ngOnInit() {
    this.etapasDeEdicaoService.setOpcaoAtual(5);

    if (this.condicaoQualidadeStateService.carregando.getValue()) {
      this.condicaoQualidadeStateService.carregando.subscribe(() => {
        this.carregarDadosInterno();
        return;
      });
    }

    this.carregarDadosInterno();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosPadrao(),
      () => this.condicaoQualidadeStateService.getPQRNumeroDiasLetivosValores()
    );
  }

  protected atualizarValores() {
    this.condicaoQualidadeStateService.setPQRNumeroDiasLetivosValores(
      this.pqrNumeroDiasLetivosValores
    );
  }

  protected openDialogPqrValoresPadrao() {
    const dialogRef = this.dialogPqrPadraoNumeroDeDias.open(
      DialogPqrPadraoNumeroDeDiasComponent,
      {
        panelClass: 'dialog-pqr-padrao-numero-de-dias',
        position: { top: '2%' },
      },
    );

    const dialogInstance = dialogRef.componentInstance as DialogPqrPadraoNumeroDeDiasComponent;
    dialogInstance.pqrNumeroDiasLetivosPadrao = this.pqrNumeroDiasLetivosPadrao;
  }

  public criaMensagemInconsistencia(): string[] {
    const mensagens: string[] = [];
    this.pqrNumeroDiasLetivosValores.forEach((valor: PQRNumeroDiasLetivosDto) => {
      if (valor.qntDiasLetivos < 1 || valor.qntDiasLetivos > 7) {
        mensagens.push(`Número de dias letivos não é válido. Informe um valor para o campo ${valor.etapaEnsino.descricao}.`);
      }
    });

    return mensagens;
  }
}

export function canDeactivateFnNumeroDeDiasLetivos(
  component: NumeroDeDiasLetivosComponent
): Observable<boolean> | boolean {
  const resultado = component.validar();

  if (!resultado.valido) {
    return false;
  }

  return true;
}